export default __webpack_public_path__ + "static/media/help.eaac5382.svg";